import React from 'react';
import CreateRequest from "../index";
import Modal from "src/shared-components/Modal";
import useAuth from "src/shared-components/Auth";

type CreateRequestModalProps = {
  onClose: () => void;
}

const CreateLegacyRequestModal = React.forwardRef(
  ({ onClose }: CreateRequestModalProps, ref) => {
    const { user } = useAuth();

    return (
      <Modal ref={ref} closeButtonForStepper maxHeight={false} closeOnBackdropClick={false}>
        <CreateRequest
          companyId={user?.companies[0]?.id}
          onRequestCreated={onClose}
        />
      </Modal>
    )
  }
);

export default CreateLegacyRequestModal;
